import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigationService} from "../services/navigation.service";
import {NavItem} from "../models/NavItem";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'cir-pub-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

  public footerLoaded: boolean = false;
  public footerErrored: boolean = false;
  public footerItems: NavItem[];
  public footerError: object;

  public currentVersion: string = environment.fullVersion;
  public build: string = environment.buildNumber;
  public buildTime: Date = new Date(environment.buildTime);
  public commit: string = environment.commit;
  public isProd: boolean = environment.production;

  constructor(private nav: NavigationService) {
  }

  ngOnInit() {
    this.nav.getFooterNav().subscribe(navItems => {
        this.footerItems = navItems;
        this.footerLoaded = true;
      }
      , error => {
        this.footerError = error;
        this.footerErrored = true;
      }
      , () => {
      });
  }

}
